import { Injectable, inject, signal } from '@angular/core';
import { catchError, of, tap } from 'rxjs';
import { SearchClient, SearchResultItemDto } from '../../api';

/** Task 10.5: federated header search bar over the generated `SearchClient`. */
@Injectable({ providedIn: 'root' })
export class GlobalSearchFacade {
  private readonly client = inject(SearchClient);

  readonly results = signal<SearchResultItemDto[]>([]);
  readonly loading = signal(false);

  search(query: string): void {
    if (query.trim().length < 2) {
      this.results.set([]);
      return;
    }

    this.loading.set(true);
    this.client
      .query(query)
      .pipe(
        tap((results) => this.results.set(results)),
        catchError(() => {
          this.results.set([]);
          return of(null);
        }),
      )
      .subscribe(() => this.loading.set(false));
  }

  clear(): void {
    this.results.set([]);
  }
}
